import { DataSource, Layout, Textbox, } from "@mcleod/components";

export abstract class AutogenLayoutEdiDeclineCodeQuickInfo extends Layout {
    sourceEdiDeclineCodes: DataSource;
    textboxDescription: Textbox;
    textboxElementID: Textbox;
    textboxReasonCode: Textbox;
    textboxVersion: Textbox;
}
